import { Text } from "@clipboard-health/ui-react";
import BusinessIcon from "@mui/icons-material/Business";
import HomeIcon from "@mui/icons-material/Home";
import { Box, Slider, Stack } from "@mui/material";
import pluralize from "pluralize";
import { useController, type UseControllerProps } from "react-hook-form";

import { WORKER_DISTANCE_CRITERIA_MAX_VALUE } from "../../constants";
import { type WorkerAvailabilityCriteriaValues } from "../../types";

type FieldValue = Pick<WorkerAvailabilityCriteriaValues, "distanceInMiles">;

type FieldName = "distanceInMiles";

export interface WorkerDistanceCriteriaProps extends UseControllerProps<FieldValue, FieldName> {
  isLoading: boolean;
  isDisabled: boolean;
}

export function WorkerDistanceCriteria(props: WorkerDistanceCriteriaProps) {
  const { name, control, isLoading, isDisabled } = props;
  const {
    field,
    formState: { isSubmitting },
  } = useController<FieldValue, FieldName>({
    name,
    control,
  });
  return (
    <Stack spacing={1}>
      <Box>
        <Text bold variant="h3">
          Maximum Distance
        </Text>

        <Text>How far are you willing to travel for work?</Text>
      </Box>

      <Stack
        spacing={1}
        justifyContent="center"
        sx={{
          paddingLeft: 6,
          paddingRight: 6,
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <HomeIcon fontSize="medium" />
          <Text bold>
            {field.value} {pluralize("mile", field.value)}
          </Text>
          <BusinessIcon fontSize="medium" />
        </Stack>
        <Slider
          disabled={isLoading || isSubmitting || isDisabled}
          valueLabelDisplay="auto"
          aria-label="Distance"
          className="distance-slider"
          data-testid="worker-distance-criteria-slider"
          min={1}
          max={WORKER_DISTANCE_CRITERIA_MAX_VALUE}
          value={field.value}
          valueLabelFormat={(value) => `${value} miles`}
          onChange={(_: Event, newValue: number | number[]) => {
            field.onChange(newValue as number);
          }}
        />
      </Stack>
    </Stack>
  );
}
